import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { IntegrityMonitorRulesGridWebComponentSchema } from '../types';

export class IntegrityMonitorRulesGridBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<IntegrityMonitorRulesGridWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
